import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex flex-row items-center gap-x3 mb-x4" }
const _hoisted_2 = ["src", "alt"]

import generateCdnUrlWithParams from '@/core/responsive/image/helpers/generate-cdn-url-including-params';
import { Certificate } from '@/types/productServerApi';


export default /*#__PURE__*/_defineComponent({
  __name: 'CertificateListItem',
  props: {
    certificate: null
  },
  setup(__props: any) {



const getCertificationImageUrl = (imageUrl: string) => {
    return generateCdnUrlWithParams(
        imageUrl,
        { format: 'auto', width: 130, height: 81 },
        true);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("div", null, [
      (__props.certificate.imageUrl)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: getCertificationImageUrl(__props.certificate.imageUrl),
            alt: __props.certificate.name
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", null, _toDisplayString(__props.certificate.name), 1)
  ]))
}
}

})